import styled from 'styled-components';
//import { Palette } from 'config';

export const LocalizationList = styled.div`
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
`;

export const Container = styled.nav``;
